<div class="header-container fx-layout-row fx-justify-start fx-align-baseline fx-gap-10">
  <span class="page-title">
    {{ 'TITLE.ORGANIZATION_CLASSES_INVENTORY' | translate }}
  </span>
  <div class="fx-flex"></div>
  <div id="work-menu" class="fx-flex-48">
    <restricted-icon-button
      icon="mdi-dots-vertical"
      iconClass="sm"
      [id]="'organization-classes-menu-button'"
      [matMenuTriggerFor]="menu">
    </restricted-icon-button>
    <mat-menu #menu="matMenu">
      <restricted-menu-item
        id="import-organization-class-menu-item"
        [preconditions]="true"
        (onClick)="importOrganizationClass()">
        {{ 'BUTTON.IMPORT_ORGANIZATION_CLASS' | translate }}
      </restricted-menu-item>
    </mat-menu>
  </div>
</div>
